import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import productData from "../Datas/productData";

const pageTitles = {
  "/": "Modern Footwear from Hong Kong",
  "/shop": "All Shoes and Boots",
  "/about": "Our Story",
  "/contact": "Contact Arenviko",
  "/shipping": "Shipping & Handling",
  "/returns": "Refund Policy",
  "/privacy": "Privacy Policy",
  "/cookies": "Cookie Policy",
  "/faqs": "Frequently Asked Questions",
  "/terms": "Terms of Service",
  "/cartpage": "Your Cart",
  "/checkout": "Checkout",
  "/paysuccess": "Order Confirmation",
  "/payment": "Payment Result",
};
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const product = pathname.startsWith("/shopDetails/")
      ? productData.find((p) => p.id === Number(pathname.split("/").pop()))
      : null;
    document.title = `${product?.name || pageTitles[pathname] || "Page"} | ${siteConfig.brandName}`;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", product?.description || siteConfig.description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${window.location.origin}${pathname}`;
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = ["/cartpage", "/checkout", "/paysuccess", "/payment"].includes(
      pathname,
    )
      ? "noindex, nofollow"
      : "index, follow";
    const icon = document.querySelector('link[rel="icon"]');
    if (icon)
      icon.href = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="8" fill="#1c1c1c"/><path d="M14 49 32 13l18 36M21 36h22" fill="none" stroke="white" stroke-width="4"/></svg>`)}`;
    const schema = document.createElement("script");
    schema.type = "application/ld+json";
    schema.textContent = JSON.stringify(
      product
        ? {
            "@context": "https://schema.org",
            "@type": "Product",
            name: product.name,
            description: product.description,
            image: product.images.map(
              (src) => `${window.location.origin}${src}`,
            ),
            sku: String(product.id),
            brand: { "@type": "Brand", name: siteConfig.brandName },
          }
        : {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: siteConfig.brandName,
            url: window.location.origin,
            description: siteConfig.description,
          },
    );
    document.head.appendChild(schema);
    let anchor = hash.slice(1);
    try {
      anchor = decodeURIComponent(anchor);
    } catch {
      /* Preserve a malformed anchor as plain text. */
    }
    let observer;
    const finishNavigation = () => {
      const main = document.querySelector("main:not([aria-busy='true'])");
      if (!main) return false;
      if (anchor) {
        const target = document.getElementById(anchor);
        if (!target) return false;
        target.scrollIntoView();
      } else {
        main.tabIndex = -1;
        main.focus({ preventScroll: true });
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
      observer?.disconnect();
      return true;
    };
    const navigationTimer = window.setTimeout(() => {
      if (finishNavigation()) return;
      // Wait for lazy content before restoring focus or resolving section links.
      observer = new MutationObserver(finishNavigation);
      observer.observe(document.body, { childList: true, subtree: true });
    }, 0);
    const timer = window.setTimeout(() => observer?.disconnect(), 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(navigationTimer);
      observer?.disconnect();
      schema.remove();
    };
  }, [pathname, hash]);
  return null;
}
